<template>
  <div class="form-group" :class="{ 'has-danger' : errors.has(name) }">
    <div class="has-float-label">
      <textarea type="text" class="form-control" :id="name" :name="name" v-bind:value="value" :ref="name" v-validate="validation" v-on:input="onInput" :placeholder="placeholder ? placeholder : label" :readonly="readonly"></textarea>
      <label :for="name">{{label}}</label>
      <div class="form-control-feedback" v-if="errors.has(name)">{{ errors.first(name) }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: String,
    placeholder: String,
    readonly: String,
    name: String,
    validation:{
      default: ''
    }
  },
  methods: {
    onInput (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>


// WEBPACK FOOTER //
// FormTextArea.vue?cb543d4a